import { useState } from "react";
import { RightArrowPointer } from "../style";
import { BASE_TYPES } from "../../constants";

const ModulePriceDialog = ({ orderItem, tableManager }) => {
  const [isAddOnPopoverOpen, setIsAddOnPopoverOpen] = useState("");
  const unitsMapper = {
    square_feet: "sq.ft.",
    running_feet: "rft.",
    number: "nos.",
  };
  const unitMapper = {
    square_feet: "/ sq.ft.",
    running_feet: "/ rft.",
    number: "/ no.",
  };
  const shellNoUnitAddons = [
    "plinth",
    "sliding_shutter_mechanism_2_door",
    "sliding_shutter_mechanism_3_door",
  ];

  const shellRunningFeetAddons = [
    "handle_type",
    "profile_handle_type",
    "g_profile_finish",
    "j_profile_finish",
    "gola_profile_floor_finish",
    "gola_profile_wall_finish",
  ];

  const toggleAddOnPopover = (id) => {
    if (isAddOnPopoverOpen == id) return;
    else setIsAddOnPopoverOpen(id);
  };

  const roundNumber = (number) => Math.round(number);

  const formatQuantity = (number) => parseFloat(number.toFixed(2));

  return (
    <div
      className="position-absolute top-0 z-3 end-0 me-1"
      style={{
        width: "max-content",
      }}
    >
      <div
        onClick={(e) => {
          e.stopPropagation();
          tableManager.clear();
        }}
        className="position-absolute bg-white rounded-circle pointer z-2"
        style={{
          top: "-0.8rem",
          right: "-0.5rem",
          border: "1px solid #283039",
          padding: "4px 6px 0 6px",
        }}
      >
        <i className="fa-solid fa-xmark fs-6" />
      </div>
      <div className="pricing-table-container">
        <table className="pricing-table">
          <tbody>
            {BASE_TYPES.map(({ type, addonsType }, baseIndex) => {
              if (!orderItem.price_meta[type]) return;
              if (orderItem.price_meta[type].measurement <= 0) return;

              const addons = orderItem.price_meta[type].addons
                .map((addon) => {
                  if (addon.price) return addon;
                })
                .filter((addon) => addon);

              addons.sort((x, y) => {
                const indexA = addonsType.indexOf(x["type"]);
                const indexB = addonsType.indexOf(y["type"]);

                if (indexA === -1 && indexB === -1) return 0; // Both not in addonsType, preserve original order
                if (indexA === -1) return 1; // `x` not in addonsType, move it after `y`
                if (indexB === -1) return -1; // `y` not in addonsType, move it after `x`

                return indexA - indexB; // Both in addonsType, sort by index in addonsType
              });

              const isTypeShell = type === "shell";
              let baseTypeRate = orderItem.price_meta[type].rate_with_addons;

              const baseTypePrice =
                orderItem.price_meta[type].price_with_addons;

              return (
                <tr
                  onMouseEnter={() =>
                    toggleAddOnPopover(orderItem.id + "_" + baseIndex)
                  }
                  onMouseLeave={() => setIsAddOnPopoverOpen("")}
                  key={`${orderItem.id}_${baseIndex}`}
                  className="position-relative"
                >
                  <td style={{ width: "300px" }}>
                    <div className="fw-bold">
                      {`${orderItem.price_meta[type].name}`}
                    </div>
                    <div className="d-flex flex-wrap">
                      {(() => {
                        let count = 0;

                        return addons.map((addon, addonIndex) => {
                          count++;

                          return (
                            <div key={addonIndex}>
                              {count !== 1 && <span className="mx-1">/</span>}
                              <span className="unit">{addon.name}</span>
                              <span className="ms-1">{addon.value_name}</span>
                            </div>
                          );
                        });
                      })()}
                    </div>
                  </td>
                  <td>
                    ₹
                    {roundNumber(
                      isTypeShell ? baseTypePrice : baseTypeRate
                    ).toLocaleString("en-IN")}{" "}
                    <span className="unit">
                      {isTypeShell
                        ? "/ no."
                        : unitMapper[orderItem.price_meta[type].unit]}
                    </span>
                  </td>
                  <td>
                    {isTypeShell
                      ? 1
                      : formatQuantity(
                          orderItem.price_meta[type].measurement
                        )}{" "}
                    <span className="unit">
                      {isTypeShell
                        ? "no."
                        : unitsMapper[orderItem.price_meta[type].unit]}
                    </span>
                  </td>
                  <td className="text-end">
                    ₹{roundNumber(baseTypePrice).toLocaleString("en-IN")}
                  </td>
                  {isAddOnPopoverOpen == orderItem.id + "_" + baseIndex && (
                    <div
                      className="d-flex align-items-center position-absolute top-50 start-100"
                      style={{
                        transform: "translateY(-50%)",
                      }}
                    >
                      <RightArrowPointer color="#283039" />

                      <div className="details-popup me-1">
                        <div
                          className="d-flex justify-content-between align-items-center px-3 column-gap-5"
                          style={{
                            marginBottom: "10px",
                          }}
                        >
                          <div>
                            {orderItem.price_meta[type].name}{" "}
                            <span className="unit">(base)</span>
                          </div>
                          <div className="fw-bold">
                            ₹
                            {roundNumber(
                              isTypeShell
                                ? orderItem.price_meta[type].price
                                : orderItem.price_meta[type].base_rate
                            )}
                          </div>
                        </div>
                        {addons.length > 0 && (
                          <>
                            <div
                              className="px-3 py-2 fw-bold bg-secondary-subtle"
                              style={{ marginBottom: "10px" }}
                            >
                              Upgrades
                            </div>
                            <div className="d-flex px-3 pb-2 column-gap-4">
                              <div className="d-flex flex-column row-gap-2">
                                {addons.map((addon, addonIndex) => (
                                  <div key={addonIndex}>
                                    <span className="unit me-2">
                                      {addon.name}
                                    </span>
                                    {addon.value_name}
                                  </div>
                                ))}
                              </div>
                              {isTypeShell && (
                                <>
                                  <div className="d-flex flex-column fw-medium row-gap-2">
                                    {addons.map((addon, addonIndex) => (
                                      <div key={addonIndex}>
                                        ₹
                                        {roundNumber(
                                          addon.base_rate
                                        ).toLocaleString("en-IN")}
                                      </div>
                                    ))}
                                  </div>
                                  <div className="d-flex flex-column row-gap-2">
                                    {addons.map((addon, addonIndex) => (
                                      <div key={addonIndex}>
                                        {formatQuantity(addon.multiplier)}{" "}
                                        <span className="unit">
                                          {shellNoUnitAddons.includes(
                                            addon.type
                                          )
                                            ? "nos."
                                            : shellRunningFeetAddons.includes(
                                                addon.type
                                              )
                                            ? "rft."
                                            : "sq.ft."}
                                        </span>
                                      </div>
                                    ))}
                                  </div>
                                </>
                              )}
                              <div className="d-flex flex-column row-gap-2">
                                {addons.map((addon, addonIndex) => (
                                  <div
                                    key={addonIndex}
                                    className="fw-bold text-end"
                                  >
                                    ₹
                                    {roundNumber(
                                      isTypeShell
                                        ? addon.price
                                        : addon.base_rate
                                    ).toLocaleString("en-IN")}
                                  </div>
                                ))}
                              </div>
                            </div>
                          </>
                        )}
                        <div className="px-3 pt-3 d-flex justify-content-end align-items-center border-top border-secondary-subtle">
                          <div className="fw-bold">Total</div>
                          <div className="ms-2 active-dimension fw-bold">
                            ₹
                            {roundNumber(
                              isTypeShell ? baseTypePrice : baseTypeRate
                            ).toLocaleString("en-IN")}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </tr>
              );
            })}
          </tbody>
        </table>
        <div className="p-3 border-top border-secondary-subtle">
          {orderItem.is_discounted && (
            <div className="d-flex justify-content-end mb-2">
              <span className="fw-bold">Total</span>
              <span className="ms-2 grey_letter fw-bold text-decoration-line-through">
                ₹{roundNumber(orderItem.original_price).toLocaleString("en-IN")}
              </span>
            </div>
          )}
          <div className="d-flex justify-content-end align-items-center">
            <span className="fw-bold">
              {orderItem.is_discounted ? "After Discount" : "Total"}
            </span>
            <span className="fs-14px ms-2 active-dimension fw-bold">
              ₹{roundNumber(orderItem.price).toLocaleString("en-IN")}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModulePriceDialog;
